'use strict';
export const SET_INIT_META_DATA = 'SET_INIT_META_DATA';
export const SET_INIT_DATA = 'SET_INIT_DATA';
export const SET_LOCAL_LANG = 'SET_LOCAL_LANG';
export const SET_DOM_READY_SCRIPT = 'SET_DOM_READY_SCRIPT';
